import ClientDetailsContainer from "@legacy/clients/ClientDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CLIENTS_ROUTES } from "@routes/clients"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function ClientDetails() {
    const [listRoute] = useSlugExtractor([CLIENTS_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("clients_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle label="Client Details" backDestination={backDestination} />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <ClientDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
